export default __webpack_public_path__ + "static/media/p2.2223cc38.png";